export enum FundRuleName {
  // Equity
  EQUITY_US = 'equityUS',
  EQUITY_LARGE = 'equityLarge',
  EQUITY_INTERNATIONAL = 'equityINT',
  EQUITY_DEVELOPED = 'equityDev',
  EQUITY_EMERGING = 'equityEmerg',
  EQUITY_GLOBAL = 'equityGlobal',
  EQUITY_NON_US = 'equityNonUs',
  EQUITY_MID = 'equityMid',
  EQUITY_SMALL = 'equitySmall',
  EQUITY_INDEX = 'equityIndex',
  EQUITY_ACTIVE = 'equityActive',
  EQUITY_BLEND = 'equityBlend',
  EQUITY_GROWTH = 'equityGrowth',
  EQUITY_VALUE = 'equityValue',

  // Strategy
  DIVIDEND_STRATEGY = 'DivStrategy',
  ESG_STRATEGY = 'ESGStrategy',
  FACTOR_DRIVEN_STRATEGY = 'FactorDrivenStrategy',
  SECTOR_SPECIALITY_STRATEGY = 'SectorSplStrategy',

  // Fixed income
  FI_US = 'fixedIncomeUS',
  FI_INTERNATIONAL = 'fixedIncomeINT',
  FI_DEVELOPED = 'fixedIncomeDev',
  FI_EMERGING = 'fixedIncomeEmerg',
  FI_GLOBAL = 'fixedIncomeGlobal',
  FI_MULTI_SECTOR = 'fixedIncomeMultiSector',
  FI_NON_US = 'fixedIncomeNonUS',
  FI_LONG = 'fixedIncomeLong',
  FI_INTERMEDIATE = 'fixedIncomeIntermediate',
  FI_SHORT = 'fixedIncomeShort',
  FI_BELOW_INV_GRADE = 'fixedIncomeBinv',
  FI_INV_GRADE_CORP = 'fixedIncomeInv',
  FI_MUNI = 'fixedIncomeMuni',
  FI_TREASURY_AGENCY = 'fixedIncomeTA',
  FI_INDEX = 'fixedIncomeIndex',
  FI_ACTIVE = 'fixedIncomeActive',

  // MultiAsset
  MULTI_ASSET_TARGET_DATE = 'multiAssetTargetDt',
  MULTI_ASSET_BALANCE = 'multiAssetBal',
  MULTI_ASSET_TARGET_ALLOCATION = 'multiAssetTargetAC',
  MULTI_ASSET_US = 'multiAssetUS',
  MULTI_ASSET_INTL = 'multiAssetIntL',

  // Cash Equivalents
  CASH_EQUIVALENTS_TAXABLE = 'cashEquivalentTaxable',
  CASH_EQUIVALENTS_MUNI = 'cashEquivalentMuni',
  CASH_EQUIVALENTS_STABLE_VALUE = 'cashEquivalentStVal',

  // Product Type
  PRODUCT_TYPE_MUTUAL_FUND = 'mf',
  PRODUCT_TYPE_ETF = 'etf',
  PRODUCT_TYPE_COLLECTIVE_TRUST = 'collTrusts',

  // Asset Class
  EQUITY = 'equity',
  FIXED_INCOME = 'fixedIncome',
  MULTI_ASSET = 'multiAsset',
  CASH_EQUIVALENT = 'cashEquivalent',
}
